import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { mapDispatchProps, mapStateToProps } from "../../store/store";
import DatePicker from "../../components/datePicker";
import dayjs from "../../plugins/dayjs";
import TextInputField from "../../components/textInput";
import Button from "../../components/button";
import API from "../../api";
import InputDate from "../../components/inputDate";
import { useLanguage } from "@languages/index";

interface PropTypes {
  campaignData?: any;

  productId?: any;

  onUpdate?: () => void;

  auth?: any;
  showModal?: (params?: any) => void;
  preferences?: any;
}

const CampaignUpdateIndex = (props: PropTypes) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const [campaign, setCampaign] = useState(props.campaignData);

  useEffect(() => {
    console.log("campaign", campaign);
  }, []);

  const handleSubmit = () => {
    const params = {
      brandToken: props.auth.token,
      productId: props.productId,
      campaignId: props.campaignData.id,
      productDeployAt: campaign.productDeployAt,
      postingStartsAt: campaign.postingStartsAt,
    };

    API.Campaign.updateProductDeployAt(params)
      .then((response) => {
        props.showModal({ text: response.message });
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      })
      .finally(() => {
        props.onUpdate ? props.onUpdate() : null;
      });
  };

  const DateInput = ({
    className,
    placeholder,
    value,
    minDate,
    onChange,
  }: any) => {
    return (
      <>
        {props.preferences.isMobile && (
          <InputDate
            modalZIndex={10000}
            className={className}
            placeholder={placeholder}
            value={value}
            minDate={minDate}
            onChange={onChange}
          />
        )}
        {!props.preferences.isMobile && (
          <DatePicker
            className={className}
            placeholder={placeholder}
            value={value}
            minDate={minDate}
            onChange={onChange}
          />
        )}
      </>
    );
  };

  return (
    <div className="flex flex-col p-10 bg-white md:w-[460px]">
      <div className="flex flex-col gap-5">
        <div className="title">
          <span className="font-bold text-xl">
            {languageTexts.update_text_1}
          </span>

          <div className="flex flex-col gap-2 mt-8">
            <span className="font-bold text-base">
              {languageTexts.update_text_2}
            </span>
          </div>

          <div className="flex flex-col">
            {campaign.products.map((item) => {
              return (
                <span className="text-sm text-[#999999]">{`${item.name} / ${item.colorName} / ${item.sizeName}`}</span>
              );
            })}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-bold text-base">
            {languageTexts.update_text_3}
          </span>
          <span className="text-sm text-[#999999]">
            {languageTexts._update_text_4()}
          </span>

          <div className="relative form-input flex flex-row items-center gap-3 mt-4 w-full">
            <DateInput
              className={"w-full"}
              placeholder={languageTexts.update_text_5}
              value={
                campaign ? campaign.productDeployAt : campaign.productDeployAt
              }
              minDate={dayjs().toDate()}
              maxDate={
                props.campaignData && props.campaignData.productDeployAt
                  ? dayjs(props.campaignData.productDeployAt).toDate()
                  : dayjs().toDate()
              }
              onChange={(value) => {
                setCampaign({
                  ...campaign,
                  productDeployAt: value,
                  postingStartsAt: dayjs(value)
                    .add(2, "day")
                    .format("YYYY-MM-DD"),
                  postingEndsAt: dayjs(value)
                    .add(2, "day")
                    .add(7, "day")
                    .format("YYYY-MM-DD"),
                });
              }}
            />
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="font-bold text-base">
            {languageTexts.update_text_6}
          </span>
          <span className="text-sm text-[#999999]">
            {languageTexts._update_text_7()}
          </span>

          <div className="form-input flex flex-row items-center gap-3 mt-4 w-full">
            <TextInputField
              disabled
              placeholder={languageTexts.update_text_8}
              value={campaign ? campaign.postingStartsAt : ""}
            />

            <span>~</span>

            <TextInputField
              disabled
              placeholder={languageTexts.update_text_9}
              value={props.campaignData.postingEndsAt}
            />
          </div>
        </div>

        <div className="flex flex-col">
          <Button
            text={languageTexts.update_text_10}
            textColor={"WHITE"}
            buttonColor={"BLACK"}
            onClick={() => {
              handleSubmit();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(CampaignUpdateIndex);
